import React, { Component } from 'react';

import axios from '../../axios-ns';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Aux from '../../hoc/Aux';
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';

class UserProfile extends Component {

    state = {
        totalScore: 0,
        daileScores: []
    }

    componentDidMount() {
        axios.get('protected/user/total-score', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, totalScore: response.data });
            });

        axios.get('protected/user/daily-scores', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, dailyScores: response.data });
            });

    }

    render() {
        let sessions = null;

        if (this.state.dailyScores) {
            sessions = this.state.dailyScores.map(s => {
                return (
                    <Aux key={Math.random()}>
                        <div style={{width: '100%', height: '30px'}}>
                        <b style={{ fontSize: '10px', float: 'left', margin: '5px' }}>{s.day}:</b>
                        <div style={{ float: 'left', backgroundColor: 'orange', height: '20px', width: Math.min(400, s.score / 500 * 100) }} /><br/>
                        </div>
                    </Aux>
                );
            })
        }
        
        return (
            <Card style={{ padding: '30px', textAlign: 'center', width: '500px', }}>
                <p>Pracuj nad swoim głosem, śledź swoje postępy i zbieraj punkty!</p>
                <CardHeader title="Twoje punkty">
                </CardHeader>
                <div style={{ fontSize: '50px', color: 'orange', float: 'center', padding: '10px', margin: 'auto' }}>
                    <OfflineBoltIcon style={{fontSize: '60px'}}/>{this.state && this.state.totalScore > 50 ? this.state.totalScore : 0}
                </div>
                <CardHeader title="Twoja praca">
                </CardHeader>
                {sessions}
            </Card>
        )
    }
}

export default UserProfile; 